export default "__VITE_ASSET__68f9a9d4__"